module.exports = __webpack_public_path__ + "img/Homework success.e50772f7.png";